import { Outlet } from 'react-router-dom';
import { LoginPage } from 'client/pages/auth/LoginPage';
import { useUser } from './User';

export const PrivateOutlet = () => {
  const user = useUser();
  if (user.isLoggedIn) return <Outlet />;
  return <LoginPage />;
};
